import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";



const ProtectedRoute = () => {
    const { user } = useAuth();
    return user ? <><div className='default-layout'>
        <Nav />
        <Outlet />
        <Footer />
    </div></> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
